import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ParallaxModule } from '../parallax.module';
import { PipeModule } from '../pipes/pipe.module';
import { BuildingBlocksModule } from './building-blocks/building-blocks.module';
import { ProjectDetailComponent } from './detail/detail.component';
import { ProjectItemComponent } from './item/item.component';
import { ProjectListComponent } from './list/list.component';
import { ProjectPreviewComponent } from './preview/preview.component';
import { ProjectRoutingModule } from './project-routing.module';
import { ProjectService } from './project.service';

@NgModule({
    imports: [
        BuildingBlocksModule,
        CommonModule,
        ParallaxModule,
        ProjectRoutingModule,
        PipeModule,
    ],
    declarations: [
        ProjectDetailComponent,
        ProjectItemComponent,
        ProjectListComponent,
        ProjectPreviewComponent,
    ],
    providers: [
        ProjectService,
    ],
    exports: [
        ProjectPreviewComponent,
    ],
})
export class ProjectModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/project.module.ts